<app-user-view [empId]="displayEmployee.id" (closePopup)="displayProfile=false" *ngIf="displayProfile"></app-user-view>
<ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="!cs.myMemberShip">
  <ion-button (click)="onClickJoinMember()" color="secondary" shape="round">
    Join
  </ion-button>
</ion-fab>
<ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="cs.myMemberShip && cs.myMemberShip.status=='Pending'">
  <ion-button (click)="cs.sendReminder()" color="secondary" shape="round">
    Send Reminder
  </ion-button>
</ion-fab>

<ion-row>
  <ion-col size="12" sizeMd="4" *ngFor="let member of cs.memberList">
    <ion-card class="padding10 ">
      <ion-row>
        <ion-col size="1.5" class="textCentre padding5">
          <img class="circular " src="{{member.profile_meta.url}}" alt="image" *ngIf="member.profile_meta.url">
          <img class="circular " src="assets/imgs/male.png" alt="image" *ngIf="!member.profile_meta.url">
        </ion-col>
        <ion-col size="8.5">
          <b class="font1_2 textCenter">{{member.profile_meta.name}} Ji {{member.profile_meta.sub_community}}</b>
          <ion-badge color="secondary" mode="ios">{{member.role}}</ion-badge>
          <ion-badge *ngIf="member.status!='Verified'" (click)="clickApproval(member)" [color]="getStatusColor(member)"
            mode="ios">{{member.status}}</ion-badge>
          <div class="font0_9">{{member.profile_meta.current_address2}}
            <ion-badge color="primary" mode="ios">{{member.profile_meta.origin_city}}</ion-badge>
          </div>
        </ion-col>
        <ion-col size="2">
          <ion-icon name="ellipsis-vertical" class="font1_5 floatRight" (click)="clickMember(member)"></ion-icon>
        </ion-col>
      </ion-row>
    </ion-card>
  </ion-col>
</ion-row>